function enableAnimatedDetails(selector = "details") {
  document.querySelectorAll(selector).forEach((details) => {
    const summary = details.querySelector("summary");
    const content = details.querySelector(".accordion-content, .collapse-content");

    if (!summary || !content) return;

    summary.addEventListener("click", (e) => {
      e.preventDefault();

      const isOpen = details.hasAttribute("open");

      // Measure current height
      const startHeight = content.offsetHeight;

      // Toggle <details>
      details.toggleAttribute("open");

      // Measure new height
      const endHeight = content.offsetHeight;

      // Set explicit start height
      content.style.height = startHeight + "px";

      // Force reflow
      content.offsetHeight;

      // Animate to new height
      content.style.height = endHeight + "px";

      // Clean up
      content.addEventListener(
        "transitionend",
        () => {
          content.style.height = "";
        },
        { once: true }
      );
    });
  });
}

// Enable for all <details> on the page
enableAnimatedDetails();
